import {Hives} from "widgets/hives";

export const HivesPage = () => {
    return (
        <>
            <Hives/>
        </>
    )
}
